<script>
	import { fade } from "svelte/transition";

	import PageSection from "../../components/PageSection.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;

	document.title = pageTitle;

	window.onbeforeunload = null;
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h1>Thank you</h1>

			<p>
				Thank you for adding supporting documentation to your registration for the {projectSettings.classActionName}.
			</p>

			<p>
				Your registration number is: <strong>{$model.RegistrationNumber}</strong>
			</p>

			<p>
				If you have any questions, please contact Shine Lawyers on <ClassActionPhoneNumber
				></ClassActionPhoneNumber
				>, or at
				<ClassActionEmailAddress></ClassActionEmailAddress>, and quote the registration number above.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}
</style>
